(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("base"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "base"], factory);
	else if(typeof exports === 'object')
		exports["widget-advanced-content-template"] = factory(require("jquery"), require("base"));
	else
		root["widget-advanced-content-template"] = factory(root["jquery"], root["base"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	/*global define, bd, be*/
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'widget-advanced-content-template';

	    var $ = __webpack_require__(3);
	    var bus = __webpack_require__(4).bus;
	    var ice = __webpack_require__(5);
	    var DraggableICEBehavior = __webpack_require__(6);

	    var setBackgroundImage = function setBackgroundImage(widget) {

	        var bgImage = $(widget.body).find('.bg-image');

	        // If there is no image, return
	        if (bgImage.length === 0) {
	            return;
	        }

	        var bgImageTarget = getBackgroundPosition(widget, widget.getPreference('bgImageContainer')),
	            bgSize = widget.getPreference('bgImageSize'),
	            bgImageScroll = widget.getPreference('bgImageScroll');

	        if (bgImage && bgImageTarget) {
	            bgImageTarget.css({
	                'background-image': 'url(' + bgImage.attr('src') + ')',
	                'background-size': bgSize,
	                'background-position': 'center top',
	                'background-repeat': 'no-repeat',
	                'background-attachment': bgImageScroll
	            });
	        }
	    };

	    var getBackgroundPosition = function getBackgroundPosition(widget, bgImagePosition) {
	        switch (bgImagePosition) {
	            case 'widget':
	                return $(widget.body).closest('.bp-widget');
	            case 'fullscreen':
	                return $("#main");
	        }
	    };

	    /**
	     * @param {jQuery} $htmlNode root node to start searching from
	     * @returns {String} background image src that is suitable for a LP background
	     */
	    function getLPBackground($htmlNode) {
	        return $htmlNode.find('.lp-background-image:first img').prop('src');
	    }

	    /**
	     * @param widget
	     */
	    var ContentAccordion = function ContentAccordion(widget) {
	        this.widget = widget;
	        this.$widget = $(widget.body);
	    };

	    ContentAccordion.prototype.init = function () {

	        ice.init(this.widget);

	        var upClass = 'lp-icon-caret-up';
	        var downClass = 'lp-icon-caret-down';
	        var $collapsible = $('.lp-faq-content', this.$widget);
	        var $arrow = $('.lp-accordion-toggle-class');

	        $('.lp-faq-title', this.$widget).click(function () {
	            var $target = $(this);
	            var isCollapsed = $target.hasClass('collapsed');

	            if (isCollapsed) {
	                $arrow.removeClass(downClass).addClass(upClass);
	                $collapsible.slideDown(300);
	            } else {
	                $arrow.removeClass(upClass).addClass(downClass);
	                $collapsible.slideUp(300);
	            }

	            $target.toggleClass('collapsed', !isCollapsed);
	        });
	    };

	    /**
	     * @param widget
	     * @constructor
	     */
	    var AdvancedContentTemplate = function AdvancedContentTemplate(widget) {
	        this.widget = widget;
	        this.$widget = $(widget.body);
	    };

	    AdvancedContentTemplate.prototype.init = function () {

	        var self = this;

	        ice.init(self.widget).then(function () {

	            self.DraggableICEBehavior = new DraggableICEBehavior(self.widget, {});
	            self.DraggableICEBehavior.init(bd.designMode);

	            self.setHeight();

	            if (self.$widget.is(':visible')) {
	                self.setBackground();
	            }

	            self.widget.model.addEventListener('PrefModified', function (evt) {
	                if (evt.attrName === 'widgetContentsUpdated') {
	                    self.setHeight();
	                    self.setBackground();
	                }
	            });

	            function launchpadShowHandler() {
	                self.setBackground();
	                if ($(self.widget.htmlNode).attr('data-event') === 'launchpad:show') {
	                    // clear "deferred" event bus
	                    $(self.widget.htmlNode).removeAttr('data-event');
	                }
	            }

	            $(self.widget.htmlNode).on('launchpad:show', function () {
	                launchpadShowHandler();
	            });

	            // expect "deferred" event in case
	            // if 'launchpad:show' was fired before 'launchpad:show' listener was added
	            if ($(self.widget.htmlNode).attr('data-event') === 'launchpad:show') {
	                launchpadShowHandler();
	            }

	            // LPES-3167
	            if (bd.designMode) {
	                var node = self.widget;
	                var panel;
	                while (node.parentNode) {
	                    node = node.parentNode;
	                    if (node.nodeName === 'TCont') {
	                        var tCont = node;
	                        break;
	                    }
	                    panel = node;
	                }

	                if (tCont) {
	                    $(tCont.htmlNode).find('.bp-tContFn-tab').on('click', function (e) {
	                        var panelIndex = tCont.childNodes.indexOf(panel);
	                        var index = $(e.currentTarget).index();
	                        // tCont childNodes are shifted and the fallback node is the first actually:
	                        // [1] -> 1
	                        // [2] -> 2
	                        // [*] -> 0 (its node is inserted first)
	                        // so we shift the index as well:
	                        index = (index + 1) % tCont.childNodes.length;

	                        if (panelIndex === index && getLPBackground($(panel.htmlNode)) === getLPBackground(self.$widget)) {
	                            self.setBackground();
	                        }
	                    });
	                }
	            }
	        });
	    };

	    AdvancedContentTemplate.prototype.setHeight = function () {
	        var height = this.widget.getPreference('height');
	        if (height) {
	            this.$widget.height(height);
	        }
	    };

	    AdvancedContentTemplate.prototype.setBackground = function () {
	        ice.fixEditing(this.widget);
	        setBackgroundImage(this.widget);
	    };

	    /**
	     * Factory for two types of content: content template and accordion.
	     * @param widget
	     */
	    var ContentFactory = function ContentFactory(widget) {
	        this.widget = widget;
	    };

	    ContentFactory.prototype.init = function () {

	        var isAccordion = this.widget.model.getPreference('templateUrl').indexOf('accordion') > -1,
	            widgetWrapper;

	        widgetWrapper = isAccordion ? new ContentAccordion(this.widget) : new AdvancedContentTemplate(this.widget);
	        widgetWrapper.init();

	        return widgetWrapper;
	    };

	    module.exports = function (widget) {
	        bus.publish('cxp.item.loaded', { id: widget.model.name });
	        var widgetWrapper = new ContentFactory(widget);
	        return widgetWrapper.init();
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    var fixEditing = function fixEditing(widget) {
	        var selector = '[content][editable=false]:not(img)',
	            restart = function restart() {
	            var name,
	                instance,
	                cke = window.CKEDITOR;

	            if (cke && cke.instances) {
	                for (name in cke.instances) {
	                    instance = cke.instances[name];
	                    if (this === instance.element.$) {
	                        instance.destroy();
	                        $(this).attr('contenteditable', true);
	                        cke.inline(this);
	                        return;
	                    }
	                }
	            }
	        };

	        $(widget.body).off('.lp-ice').on('focus.lp-ice', selector, function () {
	            $(widget.body).find(selector).each(restart);
	        }).find(selector).each(restart);
	    };

	    var init = function init(widget) {

	        var dfd = new $.Deferred();

	        // Extend widget in design mode
	        if (be.ice && bd && bd.designMode === 'true') {

	            // Clone and extend default ice config
	            widget.iceConfig = $.extend(true, {}, be.ice.config);
	            widget.iceConfig.events.push('lp-drag');

	            // var isMasterpage = be.utils.module('top.bd.PageMgmtTree.selectedLink.isMasterPage'),
	            var isMasterpage = top && top.bd && top.bd.PageMgmtTree && top.bd.PageMgmtTree.selectedLink && top.bd.PageMgmtTree.selectedLink.isMasterPage,
	                isManageable = isMasterpage || widget.model.manageable === 'true' || widget.model.manageable === '' || widget.model.manageable === undefined;

	            if (isManageable && be.ice.controller) {
	                var templateUrl = String(widget.getPreference('templateUrl')),
	                    enableEditing = function enableEditing() {
	                    return be.ice.controller.edit(widget, templateUrl).then(function (dom) {
	                        $(widget.body).find('.bp-g-include').html(dom);
	                        fixEditing(widget);
	                        return dom;
	                    });
	                };

	                return enableEditing();
	            }
	        } else {
	            // Hide broken images on live
	            $('img[src=""], img:not([src])', widget.body).addClass('be-ice-hide-image');
	            dfd.resolve();
	        }
	        return dfd.promise();
	    };

	    module.exports = {
	        init: init,
	        fixEditing: fixEditing
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/*global define, bd, be */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var $ = __webpack_require__(3);

	    /**
	     * Draggable behavior for copyright text on the promo carousel
	     *
	     * An element called 'Grippy' appears above the draggable area and dragging grippy,
	     * causes the draggable area to move
	     *
	     * @param $
	     * @param widget
	     * @param options
	     * @returns {{init: Function, position: Function, grippy: {show: Function, hide: Function}}}
	     * @constructor
	     */
	    var DraggableICEBehavior = function DraggableICEBehavior(widget, options) {

	        /**
	         * Configuration object
	         * @type {Object}
	         */
	        var config = $.extend({
	            draggableAreaSelector: '.lp-content-text-area',
	            containersSelector: '.lp-promo-slide',
	            grippyContents: 'Drag',
	            draggableClass: 'draggable',
	            preferenceName: 'content-position',
	            defaultCoordinates: {
	                top: '50px',
	                left: '50px'
	            }
	        }, options);

	        /**
	         * List of elements to drag
	         */
	        var $containers;

	        /**
	         * Widget DOM element
	         */
	        var $body = $(widget.body);

	        /**
	         * 'Constants' for code maintainability
	         */
	        var GRIPPY_CLASS = 'lp-grippy';
	        var ANIMATION_DURATION = 400;

	        /**
	         * Object holding coordinates of contents
	         */
	        var coordinates;

	        /**
	         * Where we are in portal manager, or public site
	         */
	        var isDesignMode = true;

	        /**
	         * Make element draggable.
	         *
	         * @return undefined
	         */
	        var makeDraggable = function makeDraggable(element, $handle, opt) {
	            opt = $.extend({ onStop: function onStop() {}, prevent: true }, opt);

	            var mouseMoveFn;

	            // Called when mouseup for this grippy is fired
	            var mouseUpFn = function mouseUpFn() {
	                // Cleanup
	                element.removeClass(config.draggableClass);
	                element.parents().unbind('mousemove', mouseMoveFn);
	                $(document).unbind('mouseup', mouseUpFn);

	                // Call appropriate handler
	                opt.onStop(element);
	            };

	            $handle.on('mousedown', function (e) {
	                if (opt.prevent) {
	                    e.preventDefault();
	                    e.stopPropagation();
	                }

	                element.addClass(config.draggableClass);

	                var drgH = element.outerHeight(),
	                    drgW = element.outerWidth(),
	                    posX = element.offset().top + drgH - e.pageY,
	                    posY = element.offset().left + drgW - e.pageX;

	                mouseMoveFn = function mouseMoveFn(ev) {
	                    var top = ev.pageY + posX - drgH,
	                        left = ev.pageX + posY - drgW;

	                    // Constraintment inside widget body
	                    var minTop = $body.offset().top,
	                        maxTop = minTop + $body.outerHeight(),
	                        minLeft = $body.offset().left,
	                        maxLeft = minLeft + $body.outerWidth();

	                    if (top < minTop || top > maxTop - 20 || left < minLeft || left > maxLeft - 20) {
	                        return;
	                    }

	                    // Update position
	                    element.offset({
	                        top: top,
	                        left: left
	                    });
	                };
	                element.parents().on('mousemove', mouseMoveFn);
	                $(document).on('mouseup', mouseUpFn);
	            });
	        };

	        /**
	         * Update the coordinates for the content of a specific element
	         *
	         * @param  {Object} element jQuery object of the element
	         * @return undefined
	         */
	        var refreshCoordinates = function refreshCoordinates(id, element) {
	            coordinates[id] = {
	                top: element.css('top'),
	                left: element.css('left')
	            };

	            widget.setPreference(config.preferenceName, JSON.stringify(coordinates));
	            widget.model.save();
	        };

	        /**
	         * Create & attach grippy to the element we want to drag.
	         *
	         * @return undefined
	         */
	        var attachGrippy = function attachGrippy(el) {
	            var grippy = $('<div/>').text(config.grippyContents).addClass(GRIPPY_CLASS).appendTo(el);

	            // Track grippy's hover state
	            grippy.hover(function () {
	                grippy.data('is:hover', true);
	            }, function () {
	                grippy.data('is:hover', false);
	            });

	            el.hover(function () {
	                grippy.show();

	                // Cancel hiding if reused here
	                if (grippy.data('timeout')) {
	                    clearTimeout(grippy.data('timeout'));
	                }
	            }, function () {
	                var timeoutId = setTimeout(function () {
	                    if (!grippy.data('is:hover')) {
	                        grippy.hide();
	                    }
	                }, 500);
	                grippy.data('timeout', timeoutId);
	            });

	            makeDraggable(el, grippy, {
	                onStop: function onStop(element) {
	                    refreshCoordinates(element.attr('id'), element);
	                }
	            });
	        };

	        /**
	         * Setup containers for the draggable ICE elemenents.
	         *
	         * NOTE: A number of CSS properties (like absolute position) are needed for the dragging to work.
	         * Best thing is to set them in the CSS files, but as a last resort, we set them inline with JS, if they are not set
	         *
	         * @return undefined
	         */
	        var setupContainers = function setupContainers() {
	            $containers = $(config.containersSelector, $body);

	            $containers.each(function (index, value) {
	                var el = $(value).find(config.draggableAreaSelector);

	                if (isDesignMode) {
	                    attachGrippy(el);
	                }

	                if (el.css('position') !== 'absolute') {
	                    el.css('position', 'absolute');
	                }
	            });
	        };
	        /**
	        * Position the ICE content on the screen, based on the preferences
	        *
	        * @return undefined
	        */
	        var positionContent = function positionContent() {
	            var text = $containers.find(config.draggableAreaSelector);

	            var coords = coordinates[$containers.attr('id')];

	            if (coords === 'undefined' || !coords) {
	                coords = {
	                    top: config.defaultCoordinates.top,
	                    left: config.defaultCoordinates.left
	                };
	            }

	            text.css({
	                top: coords.top,
	                left: coords.left
	            });

	            text.animate({ opacity: 1 }, ANIMATION_DURATION);
	        };

	        /**
	         * Initialization of draggables and droppables
	         *
	         * @return undefined
	         */
	        var init = function init(designMode) {
	            isDesignMode = !!designMode;
	            setupContainers();

	            try {
	                coordinates = JSON.parse(widget.getPreference(config.preferenceName));
	            } catch (e) {
	                coordinates = config.defaultCoordinates;
	            }

	            positionContent();
	        };

	        /**
	         * Cleanup markup
	         *
	         */
	        var cleanup = function cleanup(domnode) {
	            domnode = $(domnode);
	            domnode.find('.' + GRIPPY_CLASS).remove();
	            domnode.find(config.draggableAreaSelector).css({
	                top: '',
	                left: '',
	                opacity: ''
	            });
	        };

	        return {
	            init: init,
	            cleanup: cleanup
	        };
	    };

	    // Define ICE widget event

	    var iceEvents = be.ice && be.ice && be.ice.events;
	    var lpDragBehavior;

	    if (iceEvents) {

	        // init ckeditor
	        iceEvents.registerEventListener('lp-drag', function (domnode, widget) {
	            lpDragBehavior = new DraggableICEBehavior(widget, {});
	            lpDragBehavior.init(bd.designMode);
	        });

	        // cleanup ckeditor stuff
	        iceEvents.registerEventCleaner('lp-drag', function (domnode) {
	            lpDragBehavior.cleanup(domnode);
	        });
	    }

	    module.exports = DraggableICEBehavior;
	    return DraggableICEBehavior; //legacy
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** scripts/main.js
 **/